import {toShortDate} from '../../../utils/DateUtils';

const PaymentTableColumns = () => {
  return [
    {
      dataIndex:'customerName',
      key: 'customerName',
      title: 'Store Name',
    },
    {
      dataIndex:'campaignName',
      key: 'campaignName',
      title: 'Campaign Name',
    },
    {
      dataIndex:'documentSubmittedDate',
      key: 'documentSubmittedDate',
      title: 'Document Submit Date',
      render: (_, row) => toShortDate(row.documentSubmittedDate),
    },
    {
      dataIndex:'campaignStatus',
      key: 'campaignStatus',
      title: 'Current Status',
    },
    {
      dataIndex:'totalClaimAmount',
      key: 'totalClaimAmount',
      title: 'Total Claim Amount',
    },
    {
      dataIndex:'amountPaid',
      key: 'amountPaid',
      title: 'Amount Paid',
    },
    {
      dataIndex:'paymentDate',
      key: 'paymentDate',
      title: 'Payment Date',
    },
    {
      dataIndex:'utrNo',
      key: 'utrNo',
      title: 'UTR No',
    },
    {
      dataIndex:'rejectionReason',
      key: 'rejectionReason',
      title: 'Rejection Reason',
    },

  ];
};

export default PaymentTableColumns;
